import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ObjectPathService {

    public static objectPath(object: Object, path: string): any {
        if (object === undefined || object === null) {
            return undefined;
        }

        let nextObj: any = object;
        for (const nextPath of path.split('.')) {
            if (nextObj === null || nextObj === undefined) {
                return undefined;
            }
            nextObj = nextObj[nextPath];
        }
        return nextObj;
    }
}
